<script>
import CleanLayout from '@/Shared/CleanLayout'
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";
import AuthTabPanel from "./AuthTabPanel";
import AuthTabPane from "./AuthTabPane";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.title') },
    components: {
        AuthTabPane,
        AuthTabPanel,
        FlashMessages,
        TextInput,
        CleanLayout
    },
}
</script>

<template>
    <clean-layout>
        <main role="main">
            <div class="container">
                <div class="row my-5">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto text-center">
                        <h1 class="h2 font-poppins font-weight-light color-light-blue">
                            {{ Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.title') }}
                        </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <div class="card shadow border-0 border-radius-16">
                            <AuthTabPanel>
                                <AuthTabPane
                                    :active="true"
                                    aria-label="employer-tab"
                                    id="employer"
                                >
                                    <p class="font-poppins font-weight-light">
                                        {{Lang.get('employerdashboard::pages/auth/reset_multi_factor_authentication.mail_send')}}
                                    </p>
                                </AuthTabPane>
                            </AuthTabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </clean-layout>
</template>
